function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgFood1Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.998 511.998",
    style: {
      enableBackground: "new 0 0 511.998 511.998"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M275.938,485.411H51.603c-7.854,0-14.399-6.013-15.066-13.838L0.054,42.951 c-0.358-4.219,1.066-8.393,3.93-11.511c2.864-3.118,6.902-4.891,11.136-4.891h297.3c4.234,0,8.272,1.774,11.136,4.891 c2.864,3.118,4.288,7.293,3.93,11.511l-7.947,93.368c-0.708,8.321-8.07,14.496-16.348,13.784 c-8.321-0.708-14.493-8.027-13.784-16.348l6.55-76.964H31.583l33.907,398.381h210.448c8.349,0,15.12,6.769,15.12,15.12 C291.06,478.643,284.289,485.411,275.938,485.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M341.474,235.529c-7.276,0-13.688-5.263-14.903-12.675c-1.352-8.241,4.234-16.017,12.474-17.369 c16.431-2.696,47.242-13.684,56.134-23.341c16.663-18.096,18.398-41.049,17.286-52.49c-11.254,2.235-31.346,8.788-46.129,20.116 c-6.626,5.077-16.117,3.825-21.2-2.803c-5.079-6.627-3.824-16.12,2.803-21.199c16.773-12.854,36.228-19.746,46.335-22.709 c29.739-8.72,36.234-2.625,39.357,0.305c11.425,10.725,9.384,37.148,8.859,42.337c-1.541,15.223-7.14,37.456-25.065,56.927 c-16.752,18.194-57.48,30.074-73.488,32.699C343.11,235.462,342.286,235.529,341.474,235.529z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFF09E"
    },
    d: "M203.502,225.22c15.213-14.296,32.557-21.246,53.027-21.246c18.902,0,37.075,6.033,53.109,11.355 c8.743,2.902,17.122,5.682,24.25,6.972c7.126-1.29,15.506-4.07,24.25-6.972c16.034-5.322,34.207-11.355,53.109-11.355 c20.47,0,37.815,6.949,53.027,21.246c48.124,45.233,31.45,95.559,21.488,125.625l-0.513,1.559 c-9.148,27.664-43.494,117.927-101.379,117.927c-30.849,0-41.247-5.035-48.837-8.714c-0.407-0.197-0.786-0.381-1.145-0.552 c-0.358,0.171-0.738,0.355-1.146,0.552c-7.59,3.679-17.987,8.714-48.837,8.714c-57.885,0-92.23-90.263-101.379-117.927l-0.513-1.559 C172.052,320.777,155.378,270.452,203.502,225.22z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M383.868,485.449c-27.731,0-41.347-4.016-49.985-7.705c-8.688,3.707-22.304,7.705-49.979,7.705 c-66.161,0-102.976-89.723-115.734-128.298l-0.522-1.588c-10.36-31.261-29.663-89.517,25.496-141.362 c17.896-16.82,39.221-25.348,63.383-25.348c21.351,0,40.754,6.441,57.872,12.125c7.101,2.357,13.865,4.601,19.486,5.888 c5.62-1.285,12.384-3.531,19.489-5.888c17.115-5.682,36.517-12.125,57.869-12.125c24.161,0,45.487,8.528,63.383,25.348 c55.159,51.846,35.856,110.102,25.484,141.4l-0.5,1.523C486.844,395.726,450.029,485.449,383.868,485.449z M333.887,445.944 c2.218,0,4.438,0.488,6.491,1.464l1.139,0.547c6.729,3.262,14.963,7.253,42.352,7.253c48.972,0,81.083-89.593,87.024-107.553 l0.504-1.532c9.972-30.096,23.613-71.264-17.479-109.887c-12.444-11.696-26.004-17.142-42.673-17.142 c-16.463,0-33.399,5.623-48.343,10.584c-9.326,3.095-18.132,6.016-26.323,7.5c-1.778,0.322-3.606,0.322-5.384,0 c-8.191-1.482-16.997-4.405-26.32-7.498c-14.946-4.962-31.883-10.586-48.346-10.586c-16.667,0-30.227,5.448-42.673,17.143 c-41.093,38.622-27.45,79.792-17.49,109.85l0.525,1.595c5.932,17.933,38.043,107.526,87.015,107.526 c27.388,0,35.624-3.992,42.24-7.199l1.25-0.602C329.45,446.431,331.668,445.944,333.887,445.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M230.274,150.156H25.643c-8.349,0-15.12-6.769-15.12-15.12s6.771-15.12,15.12-15.12h204.632 c8.349,0,15.12,6.769,15.12,15.12S238.624,150.156,230.274,150.156z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood1Icon);
export default __webpack_public_path__ + "static/media/food1-icon.f9cde866.svg";
export { ForwardRef as ReactComponent };